<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <g
    ><path
      d="M7 13.9996C5.34 13.9996 4 15.3396 4 16.9996C4 18.3096 2.84 18.9996 2 18.9996C2.92 20.2196 4.49 20.9996 6 20.9996C8.21 20.9996 10 19.2096 10 16.9996C10 15.3396 8.66 13.9996 7 13.9996ZM20.71 4.62957L19.37 3.28957C18.98 2.89957 18.35 2.89957 17.96 3.28957L9 12.2496L11.75 14.9996L20.71 6.03957C21.1 5.64957 21.1 5.01957 20.71 4.62957Z"
      fill="currentColor"
    /></g
  >
</svg>
